import { FC } from "react";

import { ACTION_DROPDOWN_TYPE } from "shared/components";
import {
  StyledActionDropdownLabel,
  StyledActionDropdownItemProps,
} from "../styles";

export interface IActionDropdownLabel extends StyledActionDropdownItemProps {
  type: ACTION_DROPDOWN_TYPE.LABEL;
  label: string | JSX.Element;
}

export const ActionDropdownLabel: FC<IActionDropdownLabel> = ({
  label,
  ...rest
}) => {
  return (
    <StyledActionDropdownLabel {...rest}>{label}</StyledActionDropdownLabel>
  );
};
